import { render, staticRenderFns } from "./ManageBoardModal.vue?vue&type=template&id=222462a3&scoped=true"
import script from "./ManageBoardModal.vue?vue&type=script&lang=js"
export * from "./ManageBoardModal.vue?vue&type=script&lang=js"
import style0 from "./ManageBoardModal.vue?vue&type=style&index=0&id=222462a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222462a3",
  null
  
)

export default component.exports